import React from "react";
import { BrowserRouter } from "react-router-dom";
import Userroutes from "./components/user/Userroutes";

const App = () => {
  return (
    <BrowserRouter>
      <div style={{ paddingTop: "70px" }}>
        <Userroutes />
      </div>
    </BrowserRouter>
  );
};

export default App;
